import { Component } from '@angular/core';
import { Subscription, timer } from 'rxjs';

import { DataLayerBaseComponent } from './data-layer-base.component';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { UserMessageService } from './user-message.service';

declare var L;

@Component({
	selector: 'data-layer-tms',
	template: `
		<div class="checkboxDiv">
			<label class="overlay-layer" title={{titleString}}>
				<input type="checkbox" (click)="menuControlSelected($event)">{{htmlElementLabel}}
			</label>
			<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>
		`,
	styleUrls: ['app.component.css']
})
export class DataLayerTMSComponent extends DataLayerBaseComponent {
	currentRadarIndex = 0; // Current radar animation frame shown.	
	layerArray = []; // Caches layers to reduce the number of website queries.
	lastLayer; // holds the previous radar image so it can be removed on looping
	loop = false; // whether to loop or not
	maxImages = 12; // maximum number of radar images to display
	opacity = 0.4; // opacity of the layer to show
	radarIndexStrings = []; // the strings that distiguish each frame of the radar animation

	subscription: Subscription; // Used with the timer to get a new animation frame every 1/2 second
	timer; // Used to get a new animation frame every 1/2 second.
	titleString = ""; // Label for the sidebar element.

	constructor(
		mapService: MapService,
		dataLayerService: DataLayerService,
		configService: ConfigService,
		userMessageService: UserMessageService) {
		super(mapService, dataLayerService, configService, userMessageService);

		this.currentRadarIndex = 0;
		this.radarIndexStrings = [
			'-m55m',
			'-m50m',
			'-m45m',
			'-m40m',
			'-m35m',
			'-m30m',
			'-m25m',
			'-m20m',
			'-m15m',
			'-m10m',
			'-m05m',
			''
		];

		this.timer = timer(2000, 500);
			this.subscription = this.timer.subscribe( t => {
				this.displayRadar();
			});	
		
		this.titleString='Images 5 minutes apart. Activate and hover for more detailed information.';
	}

    menuControlSelected (event): void {
		if ( event.target.checked ) {
			this.activateLayer();
		} else {
			this.deactivateLayer();
		}

	}

	setData ( someData: any ) {
        super.setData(someData);
		if ( someData.hasOwnProperty('loop')) {
			this.loop = someData.loop;
		}
		if (someData.hasOwnProperty('opacity')) {
			this.opacity = someData.opacity;
		}
	}

	// refreshLayer first checks to see if the layer is active.  If so, activateLayer is called.
	refreshLayer() {
		if ( this.active === true ) {
			this.activateLayer();
		}
	}

    activateLayer(): void {
        console.log('Activating ' + this.id + ' layer.');
		if ( this.mapLayer != null ) {
			this.mapService.map.removeLayer(this.mapLayer);
		}
		if ( this.value == null || this.refresh === true ) {
			// once the data file has been read, drawMarkers is automatically called because an observer has been established
			this.parseDataFile();
		}


		// activate legend as well
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		if ( legendDisplay != null ) {
			legendDisplay['source'].next (true);
		}

		this.active = true;
		this.titleString = "Images from current time to 55 minutes ago."
    }

	deactivateLayer() {
		console.log('Deactivating ' + this.id + ' layer.');
		if ( this.active === true ) {
			if (this.mapLayer != null) {
				this.mapService.map.removeLayer(this.mapLayer);
				this.mapLayer = null;
			}
			if (this.lastLayer != null) {
				this.mapService.map.removeLayer(this.lastLayer);
				this.lastLayer = null;
			}
			this.currentRadarIndex = 0;

			this.active = false;
		}
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		if ( legendDisplay != null ) {
			legendDisplay['source'].next (false);
		}
	}

	displayRadar() {
		if (this.active === false) {
			return;
		}

		let url = this.value.replace('{t}', this.radarIndexStrings[this.currentRadarIndex]);

		if (this.loop) {
			if (this.currentRadarIndex == 0) {
				if (this.mapLayer != null) {
					this.mapService.map.removeLayer(this.mapLayer);
					this.mapLayer = null;
				}
				if (this.lastLayer != null) {
					this.mapService.map.removeLayer(this.lastLayer);
					this.lastLayer = null;
				}
			}

			let prevLayer = this.mapLayer;

			if (this.layerArray.length == this.currentRadarIndex) {
				let mapLayer = L.tileLayer(url);
				this.layerArray.push(mapLayer);
				this.mapLayer = mapLayer;
			}
			else {
				// using cached layer
				this.mapLayer = this.layerArray[this.currentRadarIndex];
				if (!this.mapLayer) {
					// cache doesn't contain layer, create it.
					let mapLayer = L.tileLayer(url).addTo(this.mapService.map);
					this.layerArray[this.currentRadarIndex] = mapLayer;
					this.mapLayer = mapLayer;
				}
			}

			this.mapLayer.addTo(this.mapService.map).bringToFront();
			this.mapLayer.setOpacity(this.opacity);

			if (this.lastLayer != null) {
				this.mapService.map.removeLayer(this.lastLayer);
			}

			this.lastLayer = prevLayer;

			if (this.maxImages > (this.currentRadarIndex + 1)) {
				this.currentRadarIndex += 1;
			}
			else {
				this.currentRadarIndex = 0;
			}
		}
		else {
			this.mapLayer = L.tileLayer(url).addTo(this.mapService.map)
				.bringToFront();
			this.mapLayer.setOpacity(this.opacity);
		}
	}

	parseDataFile () {
		console.log('In data-layer-tms.parseDataFile.');
		if ( this.url.startsWith('http')) {
			this.value = this.url;
		} else {
			this.value = this.configService.baseDir + this.url + '?nocache=' + (new Date()).getTime();
		}
	}
}